import React, { useEffect, useState } from "react";
import "./BookEvent.css";
import { getCalender } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function BookEvent() {
  const[bookeddate,setBookedDate]=useState([])
  const navigate=useNavigate()
  const[date,setDate]=useState("")

  const getcalender=async()=>{
    try {
      const res=await getCalender()
      console.log("calender",res);
      setBookedDate(res.data.data)
    } catch (error) {
      console.log(error);
      
    }
  }

const handlerCheck = async (date) => {
  const found = bookeddate.find((item) => {
    try {
      // Step 1: parse string -> array
      const parsed = JSON.parse(item.event_dates);

      // Step 2: split combined string into proper dates
      const datesArray = parsed[0].split(',').map(d => d.trim());

      // Step 3: match input date
      return datesArray.includes(date);

    } catch (err) {
      console.error("Invalid event_dates format", err);
      return false;
    }
  });

  if (found) {
    toast.info("Date is already booked");

  } else {
  
      toast.success("Date available make booking!");
    navigate("/booking")
  }
};

  useEffect(() => {
    getcalender()
  }, [])
  
  return (
    <section className="book-section">
      <div className="book-container">

        {/* Left Side */}
        <div className="book-left">
          <h2>Book Your Date</h2>
          <p>
            Secure your preferred date early.
            Our team will get back to you within
            24 hours to confirm availability and
            discuss packages.
          </p>

          <div className="divider"></div>

          <span className="inquiry-text">FOR IMMEDIATE INQUIRIES</span>
          <h3>+1 (555) 123-4567</h3>
        </div>

        {/* Right Side */}
        <div className="book-right">

          <div className="form-grid">
            <div className="form-group">
              <label>EVENT DATE</label>
              <input type="date"
              value={date} onChange={(e)=>setDate(e.target.value)} />
            </div>

            <div className="form-group">
              <label>EVENT TYPE</label>
              <select>
                <option>Wedding</option>
                <option>Reception</option>
                <option>Corporate Event</option>
                <option>Birthday</option>
              </select>
            </div>

            <div className="form-group">
              <label>GUEST COUNT</label>
              <input type="number" placeholder="100" />
            </div>

            <div className="form-group">
              <label>YOUR EMAIL</label>
              <input type="email" placeholder="example@email.com" />
            </div>
          </div>

          <button className="submit-btn"
          onClick={()=>handlerCheck(date)}>
            CHECK AVAILABILITY & GET QUOTE
          </button>

        </div>
      </div>
    </section>
  );
}